import { render, staticRenderFns } from "./NotFoundView.vue?vue&type=template&id=1326bcba&scoped=true"
import script from "./NotFoundView.vue?vue&type=script&lang=js"
export * from "./NotFoundView.vue?vue&type=script&lang=js"
import style0 from "./NotFoundView.vue?vue&type=style&index=0&id=1326bcba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1326bcba",
  null
  
)

export default component.exports